import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { first, retry, share, timeout } from 'rxjs/operators';
import { Observable } from 'rxjs';

const CONNECTION_TIMEOUT = 60 * 1000;

@Injectable({
	providedIn: 'root'
})
export class ReportDownloadService {

	private readonly CUSTOM_FILE_NAME_HEADER = 'x-file-name';

	constructor(public httpClient: HttpClient) {
	}

	/**
	 * The backend authentication is header-based. So file download cannot be implemented just by adding "a" tag to html.
	 * So it's needed to be implemented this way:
	 */
	downloadMigrationResultsReport(migrationId: string): Observable<HttpResponse<Blob>> {
		const url = `/api/migration-orchestrator/v1/results/${migrationId}/details/report`;
		const observable = this.httpClient.get(url, {responseType: 'blob', observe: 'response'})
			.pipe(
				retry(1),
				timeout(CONNECTION_TIMEOUT),
				share()
			);
		observable
			.pipe(first())
			.subscribe((response: HttpResponse<Blob>) => {
				const link = document.createElement('a');
				link.href = this.createDownloadUrl(response.body);
				link.download = this.getFileName(response);
				this.clickOnLinkToDownloadFile(link);
			});

		return observable;
	}

	private createDownloadUrl(blob: Blob): string {
		return window.URL.createObjectURL(blob);
	}

	private getFileName(response: HttpResponse<Blob>): string {
		return response.headers.get(this.CUSTOM_FILE_NAME_HEADER);
	}

	public clickOnLinkToDownloadFile(link: HTMLAnchorElement) {
		link.click();
	}
}
